import { getClientSessionId, getSessionId } from '@repo/common-utils';

import { SendEventParams, SendEventReturn, SetUserParams } from '../types';

export abstract class BaseService {
  protected readonly appId: string;
  protected readonly clientId: string;

  constructor(appId: string, clientId: string) {
    this.appId = appId;
    this.clientId = clientId;
  }

  protected get commonAttributes(): Record<string, string> {
    return {
      zenv: process.env.NEXT_PUBLIC_ZENV ?? 'dev',
      app_id: this.appId,
      client_id: this.clientId,
      session_id: this.sessionId,
      client_session_id: this.clientSessionId
    };
  }

  protected abstract init(): void;
  abstract setUser(params: SetUserParams): void;
  abstract sendEvent(params: SendEventParams): SendEventReturn | Promise<SendEventReturn>;

  private get sessionId(): string {
    return getSessionId();
  }

  private get clientSessionId(): string {
    return getClientSessionId();
  }

  abstract unsetUser(): void;
}
